// mood, device의 상태
// 뷰티 타입 (0: DEFAULT, 1: NONE, 2: LOW, 3: HIGH)
import { create } from 'zustand';

interface BeautiState {
  beautiType: number;
  setBeautiMode: (mode: number) => void;
  setBeautiType: (type: number) => void;
}

const useBeautiStore = create<BeautiState>((set, get) => ({
  beautiMode: 0,
  beautiType: 0,
  setBeautiMode: (cameraNum: number) => {
    const beautiType = get().beautiType;
    let sigmaC = 0.1;
    let sigmaS = sigmaC * sigmaC;
    const sharpness = 0.8;
    let pixel = 3.0;
    if (Device.name === 'android') {
      sigmaC = 0.07;
      sigmaS = sigmaC * sigmaC;
    }
    if (cameraNum === 1) {
      sigmaC = 0.07;
      sigmaS = sigmaC * sigmaC;
    }
    if (beautiType === 2) {
      pixel = 2.0;
    }

    if (beautiType === 3) {
      Device.setBeautiMode(cameraNum, 1);
      Device.setBeautiFilterParameter(cameraNum, sigmaS, sigmaC, pixel, sharpness);
      return true;
    } else if (beautiType === 2) {
      Device.setBeautiMode(cameraNum, 1);
      Device.setBeautiFilterParameter(cameraNum, sigmaS, sigmaC, pixel, sharpness);
      return true;
    } else if (beautiType === 1) {
      Device.setBeautiMode(cameraNum, 0);
      return false;
    } else if (beautiType === 0) {
      Device.setBeautiMode(cameraNum, 1);
      Device.setBeautiFilterParameter(cameraNum, sigmaS, sigmaC, pixel, sharpness);
      return false;
    }
  },
  setBeautiType: (type: number) => {
    set({ beautiType: type });
    const sigmaC = 0.07;
    const sigmaS = sigmaC * sigmaC;
    if (type === 3) {
      Device.setBeautiFilterParameter(0, sigmaS, sigmaC, 3.0, 0.8);
    } else if (type === 2) {
      Device.setBeautiFilterParameter(0, sigmaS, sigmaC, 2.0, 0.8);
    } else if (type === 1) {
      Device.setBeautiMode(0, 0);
    }
  },
}));

export default useBeautiStore;
